import { useNavigate } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "./ui/sheet";
import { track } from "../lib/analytics";
import { getLast } from "../lib/storage";
import {
  BookOpen, Sparkles, CalendarCheck, HeartHandshake, Brain,
  NotebookPen, Users, Headphones, Home, Crown, UsersRound, Bookmark, Compass, Languages,
} from "lucide-react";

export const TOOLS = [
  { to: "/read", label: "Read the Bible", desc: "Immersive WEB reader", icon: BookOpen, bg: "/cards/translation.jpg" },
  { to: "/word-study", label: "Word Study", desc: "Original Hebrew, Greek & Aramaic meaning", icon: Languages, bg: "/cards/translation.jpg" },
  { to: "/journey", label: "Reading Journey", desc: "See your history & Bible coverage", icon: Compass, bg: "/cards/plans.jpg" },
  { to: "/devotionals", label: "Daily Devotionals", desc: "Personalized to your themes", icon: Sparkles, bg: "/cards/devotionals.jpg" },
  { to: "/saved", label: "Saved Verses", desc: "Your bookmarked verses", icon: Bookmark, bg: "/cards/stat-saved.jpg" },
  { to: "/plans", label: "Reading Plans", desc: "Guided journeys", icon: CalendarCheck, bg: "/cards/plans.jpg" },
  { to: "/listen", label: "Audio Bible", desc: "Listen & follow along", icon: Headphones, bg: "/cards/audio.jpg" },
  { to: "/characters", label: "Character Cards", desc: "Meet the people of Scripture", icon: UsersRound, bg: "/cards/characters.jpg" },
  { to: "/journal", label: "Prayer Journal", desc: "Track & answer prayers", icon: HeartHandshake, bg: "/cards/prayer.jpg" },
  { to: "/memorize", label: "Verse Memorization", desc: "Spaced-repetition practice", icon: Brain, bg: "/cards/memorize.jpg" },
  { to: "/notes", label: "Sermon Notes", desc: "Capture every message", icon: NotebookPen, bg: "/cards/notes.jpg" },
  { to: "/family", label: "Family Sharing", desc: "Pray together", icon: Users, bg: "/cards/family.jpg" },
  { to: "/premium", label: "Clarity Bible Premium", desc: "Unlock everything", icon: Crown, bg: "/cards/premium.jpg" },
];

export default function AppMenu({ open, onOpenChange }) {
  const navigate = useNavigate();
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="font-ui w-full max-w-sm overflow-y-auto" data-testid="app-menu">
        <SheetHeader>
          <SheetTitle className="font-serif-display text-2xl">Clarity Bible Tools</SheetTitle>
          <SheetDescription className="sr-only">Navigate to all study tools</SheetDescription>
        </SheetHeader>
        <nav className="mt-4 space-y-2">
          {TOOLS.map((t) => (
            <button
              key={t.to}
              data-testid={`menu-${t.to === "/read" ? "read" : t.to.slice(1)}`}
              onClick={() => {
                track("feature_open", { feature: t.label, source: "tools_menu" });
                onOpenChange(false);
                if (t.to === "/read") {
                  const last = getLast();
                  navigate(last ? `/read/${last.book}/${last.chapter}` : "/read/JHN/1");
                } else {
                  navigate(t.to);
                }
              }}
              className="flex w-full items-center gap-4 rounded-2xl border border-border bg-background/40 p-4 text-left transition-all hover:border-primary/50 hover:bg-muted"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/15 text-primary">
                <t.icon className="h-5 w-5" />
              </span>
              <div>
                <p className="text-sm font-semibold">{t.label}</p>
                <p className="text-xs text-muted-foreground">{t.desc}</p>
              </div>
            </button>
          ))}
        </nav>
      </SheetContent>
    </Sheet>
  );
}
